// デモの入力内容を、この端末・ブラウザの localStorage にだけ一時保存する。
// キー名は本登録画面側と共有するため demo.md で固定（変更不可）。
const KEY = "skilllog_demo_draft";

export const loadDemoInput = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || null;
  } catch {
    return null;
  }
};

export const saveDemoInput = (values) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(values));
  } catch {
    // プライベートブラウズ・容量超過などは保存できなくても無視（デモは動く）
  }
};

export const clearDemoInput = () => {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* noop */
  }
};
